module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAABFElEQVQoU2NkwAFmzpxZ+/z589aGhoZ/MCWMeBTfZWRkPPTs2bNkmAYMxYsWLeL+9euX5N+/f/cBDZIFalgA0wBWDLSS6////7lAiWggVweIUQyBaWCcPn26NBMTE8gUNVxOAoqD3O3CCDR1BZARjqTwN5D9AoglgJgVpBBoa2ZGRsYskOK7QAElIP4LxEWCgoKzw8LCvkPFFWAKQYYxzpo16wxQwBjIXpuenh4CswEofvvfv3/dIBPhQQc0oR3IqQBqWAWUgDtnxowZXkD+NmR/ME6ZMkWYlZX1JFBQkoWFRTU5OfkZLo+Cg2jSpEmi7Ozs3UDTlYDB5AF0zjdsGlDCc/bs2eJ//vzRBFp/EKjpP7oGAIu5eJv09yoBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zf.png
// module id = 5CCU
// module chunks = 15